<template>
    <svg
        fill="none"
        height="11"
        viewBox="0 0 15 11"
        width="15"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.808124 5.15811L5.18312 0.783111C5.301 0.669262 5.45888 0.606266 5.62275 0.60769C5.78662 0.609114 5.94338 0.674844 6.05926 0.790724C6.17514 0.906605 6.24087 1.06336 6.2423 1.22724C6.24372 1.39111 6.18072 1.54898 6.06687 1.66686L2.75875 4.97499H13.75C13.9158 4.97499 14.0747 5.04083 14.1919 5.15804C14.3092 5.27525 14.375 5.43423 14.375 5.59999C14.375 5.76575 14.3092 5.92472 14.1919 6.04193C14.0747 6.15914 13.9158 6.22499 13.75 6.22499H2.75875L6.06687 9.53311C6.12657 9.59076 6.17418 9.65973 6.20694 9.73598C6.23969 9.81224 6.25694 9.89425 6.25766 9.97724C6.25838 10.0602 6.24256 10.1425 6.21114 10.2193C6.17971 10.2961 6.1333 10.3659 6.07462 10.4246C6.01594 10.4833 5.94616 10.5297 5.86935 10.5611C5.79253 10.5926 5.71024 10.6084 5.62725 10.6076C5.54426 10.6069 5.46225 10.5897 5.386 10.5569C5.30974 10.5242 5.24078 10.4766 5.18312 10.4169L0.808124 6.04186C0.690954 5.92466 0.625133 5.76571 0.625133 5.59999C0.625133 5.43426 0.690954 5.27532 0.808124 5.15811Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps<{
        background?: string;
    }>();

    const background = computed(() => props.background || '#FFFFFF');
</script>

<style scoped></style>
